<template>
  <TheMainContent>
    <RevContainer />
  </TheMainContent>
</template>

<script lang="ts" setup>
import { useHead } from '#imports'

import { RevContainer } from '@ds/components/Container'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'

useHead({
  meta: [{ name: 'robots', content: 'noindex' }],
})
</script>
